import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ShowButton,
  TextField,
  EditButton,
  TextInput,
  SelectInput,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const providersFilters = [
  <TextInput label="Search" source="name" alwaysOn />,
  <TextInput label="Contact name" source="contact_name" />,
  <TextInput label="Contact position" source="contact_position" />,
  <SelectInput
    label="Relation"
    source="relation"
    choices={[
      { id: "Friend/Family", name: "Friend/Family" },
      { id: "Customer", name: "Customer" },
      { id: "Partner", name: "Partner" },
      { id: "Other", name: "Other" },
    ]}
  />,
  <TextInput label="Email" source="email" />,
  <TextInput label="Phone number" source="phone_number" />,
];

export const ProvidersList = (props) => (
  <List
    {...props}
    actions={<MyListActions />}
    filters={providersFilters}
    sort={{ field: "name", order: "ASC" }}
    pagination={<MyListPagination />}
    perPage={100}
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="contact_name" />
      <TextField source="contact_position" />
      <TextField source="relation" />
      <TextField source="email" />
      <TextField source="phone_number" />
      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
);
